export const trainerMedicalColumns = [
    {
        field: "allergies",
        headerName: "Allergies",
        width: 160,
    },
    {
        field: "conditions",
        headerName: "Conditions",
        width: 160,
    },
    {
        field: "medications",
        headerName: "Medications",
        width: 160
    },
    {
        field: "previousInjury",
        headerName: "Previous Injury",
        width: 160,
    },
    {
        field: "userName",
        headerName: "User Name",
        width: 160,
    },
    {
        field: "email",
        headerName: "User Email",
        width: 160,
    },
    {
        field: "clientNumber",
        headerName: "User Contact No.",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];